import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../authReducer";
import loader from "../loader";
import sync from "../syncReducer";
import permissions from "../permissions/index";

export default combineReducers({
  authReducer,
  loader,
  sync,
  permissions,
});
